/* eslint-disable space-before-function-paren */
import Vue from 'vue'
import Router from 'vue-router'

import Startseite from '@/components/pages/Startseite'
import DatabaseNew from '@/components/pages/DBNew'
import Page from '@/components/pages/Page'
import Posts from '@/components/pages/Posts'
import News from '@/components/pages/News'
import Rooms from '@/components/pages/Rooms'
import Album from '@/components/pages/Album'
import Genealogie from '@/components/pages/Genealogie'
import Archivbestaende from '@/components/pages/Archivbestaende'
import PageNotFound from '@/components/pages/PageNotFound'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Startseite',
      component: Startseite,
      label: { de: 'Startseite', en: 'Home' },
      displayNav: true,
      listItemCssClass: 'navitem_start',
      initNavOpen: true,
      position: 1
    },
    {
      path: '/db/:oid?',
      alias: '/object/:oid?',
      name: 'Database',
      component: DatabaseNew,
      label: { de: 'Datenbank', en: 'Database' },
      displayNav: true,
      listItemCssClass: 'navitem_database',
      initNavOpen: true,
      position: 2
    },
    {
      path: '/posts/:cid?',
      name: 'Posts',
      component: Posts,
      label: { de: 'Beiträge', en: 'Articles' },
      displayNav: true,
      listItemCssClass: '',
      initNavOpen: true,
      position: 2
    },
    {
      path: '/posts/:cid/:pid',
      name: 'Post',
      component: Posts,
      label: { de: 'Beitrag', en: 'Article' },
      displayNav: false,
      listItemCssClass: '',
      initNavOpen: true,
      position: 0
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      label: { de: 'Aktuelles', en: 'News' },
      displayNav: true,
      listItemCssClass: '',
      initNavOpen: true,
      position: 3
    },
    {
      path: '/news/:pid',
      name: 'NewsId',
      component: News,
      label: { de: 'Aktuelles', en: 'News' },
      displayNav: false,
      listItemCssClass: '',
      initNavOpen: true,
      position: 0
    },
    {
      path: '/page/:slug',
      name: 'Seite',
      component: Page,
      label: { de: 'Seite', en: 'Page' },
      displayNav: false,
      listItemCssClass: '',
      initNavOpen: true,
      position: 0
    },
    {
      path: '/rooms',
      name: 'Rooms',
      component: Rooms,
      label: { de: 'Mosse-Palais', en: 'Mosse-Palais' },
      displayNav: true,
      listItemCssClass: '',
      initNavOpen: true,
      position: 6
    },
    {
      path: '/album',
      name: 'Album',
      component: Album,
      label: { de: 'Album Amicorum', en: 'Album Amicorum' },
      displayNav: true,
      listItemCssClass: '',
      initNavOpen: true,
      position: 7
    },
    {
      path: '/genealogie',
      name: 'Genealogie',
      component: Genealogie,
      label: { de: 'Genealogie', en: 'Genealogy' },
      displayNav: true,
      listItemCssClass: '',
      initNavOpen: true,
      position: 8
    },
    {
      path: '/archivbestaende',
      name: 'Archivbestaende',
      component: Archivbestaende,
      label: { de: 'Archivbestände', en: 'Archive holdings' },
      displayNav: false,
      listItemCssClass: '',
      initNavOpen: true,
      position: 9
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound,
      label: { de: 'Seite nicht gefunden', en: 'Page not found' },
      displayNav: false,
      listItemCssClass: '',
      initNavOpen: true,
      position: 0
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/plans' && from.path === '/plans') {
    window.location.href = to.path
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js